import { BaseTag }   from "mixs/base/base_mixin";
import { Global, CellPosition, LineMemo } from "mixs/orders/planner/model";
import moment from 'moment';
export class PlannerBase extends BaseTag {
  watchPlannerData(subScope = '', callback: (newVal: any, oldVal: any, objectPath: string) => void){
    let scope = 'planner.orders_planner'
    if(subScope != ''){ scope = scope + '.' + subScope; }
    this.watchData(scope, callback);
  }
  dataScopeOrder(id){    return Global.dataScopeOrder(id); }
  dataScopeLine(id){     return Global.dataScopeLine(id); }
  dataScopeTask(id){     return Global.dataScopeTask(id); }
  dataScopeSchedule(id){ return Global.dataScopeSchedule(id); }
  dataScopePhase(id){    return Global.dataScopePhase(id); }
  dataScopeTaskable(id, type){    return Global.dataScopeTaskable(id, type); }

  getPlannerData(){      return Global.getPlannerData(); }
  getOrderData(id){      return Global.getOrderData(id); }
  getLineData(id){       return Global.getLineData(id); }
  getTaskData(id){       return Global.getTaskData(id); }
  getScheduleData(id){   return Global.getScheduleData(id); }
  getPhaseData(id){      return Global.getPhaseData(id); }
  getLocationData(id){      return Global.getLocationData(id); }
  getTaskableData(id, type){ return Global.getTaskableData(id, type); }
  getLocationsPersonData(id){      return Global.getLocationsPersonData(id); }
}

export class Planner extends PlannerBase {
  protected topScope: string = 'planner'
  protected dispatchAction(){ return App.actions.planner.update; }
}

export class Line extends PlannerBase {
  protected topScope: string = 'lines'
  protected dispatchAction(){ return App.actions.planner.lines; }
}

export class Task extends PlannerBase {
  protected topScope: string = 'tasks'
  protected dispatchAction(){ return App.actions.planner.tasks; }
}

export class Memo extends PlannerBase {
  protected topScope: string = 'memos'
  protected dispatchAction(){ return App.actions.planner.memos; }
}

export class Taskable extends PlannerBase {
  protected topScope: string = 'taskables'
  protected dispatchAction(){ return App.actions.planner.taskables; }
}

export class Location extends PlannerBase {
  protected topScope: string = 'locations'
  protected dispatchAction(){ return App.actions.planner.locations; }
}

export class Schedule extends PlannerBase {
  protected topScope: string = 'schedules'
  protected dispatchAction(){ return App.actions.planner.schedules; }
}

export class Order extends PlannerBase {
  protected topScope: string = 'orders'
  protected dispatchAction(){ return App.actions.planner.orders; }
}

export class PlannerMemo extends Schedule {
  number:Array<undefined|boolean> = [];
  init(){
    super.init();
    this.watch();
    this.resetPosition()
    this.setBackgroundColor();
  }
  setBackgroundColor(){
    let taskData  = this.getTaskData(this.opts.task_id);
    let phaseData = this.getPhaseData(taskData.phase_id);
    this.rootElement().style.backgroundColor = phaseData.colorcode;
  }
  public onChangeStore(newVal, oldVal, objectPath) {
    this.resetPosition();
    super.onChangeStore(newVal, oldVal, objectPath);
  }
  resetPosition(){
    let pos = this.newCellPosition();
    if(pos.isStartOverRight || pos.isEndOverLeft){
      this.listenMount([this.onMountToUnmount])
      return;
    }
    pos.setStyleFor(this.rootElement());
    this.number = new Array(this.opts.length)
    let g = Global.getPlannerData()
    if(g && g.start > this.opts.start_time){
      let diffDays = moment(Global.getPlannerData().start).diff(this.opts.start_time, 'days')
      for(let i=0; i<diffDays; i++){
        this.number[i] = true;
      }
    }
  }
  onMountToUnmount(){
    let el = this.rootElement()
    el.parentNode.removeChild(el);
    this.unmount();
  }
  genTagScopeForMemo(localIndex){
    let lineMemo = this.newLineMemoLocal(localIndex);
    return Global.dataScopeTasksMemo(lineMemo.composite_id());
  }
  newCellPosition(){
    return new CellPosition(this.opts.start_time, this.opts.end_time);
  }
  newLineMemoLocal(localIndex){
    return new LineMemo(this.opts.line_id, this.opts.id, localIndex);
  }
}
riot.mixin('orders.planner.base',     PlannerBase as riot.TagMixin)
riot.mixin('orders.planner.planner',  Planner as riot.TagMixin)
riot.mixin('orders.planner.task',     Task as riot.TagMixin)
riot.mixin('orders.planner.memo',     Memo as riot.TagMixin)
riot.mixin('orders.planner.taskable', Taskable as riot.TagMixin)
riot.mixin('orders.planner.location', Location as riot.TagMixin)
riot.mixin('orders.planner.schedule', Schedule as riot.TagMixin)
riot.mixin('orders.planner.line',     Line as riot.TagMixin)
riot.mixin('orders.planner.order',    Order as riot.TagMixin)
